import React from 'react';
import PageableTable from '../pageableTable/PageableTable';
import useTableData from '../pageableTable/useTableData';
import PageableTables from '../pageableTable/PageableTables';
import { sendEmail } from '../../../core/email/sendEmail';
import { toastr } from 'react-redux-toastr';
import { mutate } from '../../../core/createApolloClient/createApolloClient.client';
import DocumentManagement from './DocumentManagementQuery.graphql';

const handleUpdateCurried = removeRow =>
  async function(row, status) {
    const { id, user_profiles: userProfiles, email } = row.original;
    const fileNames = row.original.document_verifications.map(x => x.file_name);
    const { data } = await mutate(DocumentManagement, {
      userId: id,
      isIdVerification: status,
      fileNames,
    });

    const profile = userProfiles && userProfiles.length > 0 ? userProfiles[0] : {};
    const { firstName } = profile;

    if (data.DocumentManagement.status === 'success') {
      let msg = 'Documents have been ';
      msg += status ? 'Approved!' : 'Rejected!';
      let content = {
        name: firstName,
        verificationStatus: status ? 'approved' : 'rejected',
      };
      await sendEmail(email, 'documentVerification', content);
      toastr.success('Success!', msg);
      removeRow(row.index);
    } else {
      toastr.success('Error!', 'Something went wrong!');
    }
  };
const getActions = handleUpdate => [
  {
    Header: 'Approve',
    id: 'approve', // It needs an ID
    Cell: args => {
      // Use Cell to render an expander for each row.
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      return (
        <div>
          <span onClick={() => handleUpdate(args.row, true)} className="primary pointer bold">
            Approve
          </span>
        </div>
      );
    },
  },
  {
    Header: 'Reject',
    id: 'reject', // It needs an ID
    Cell: ({ row }) => (
      // Use Cell to render an expander for each row.
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      <div>
        <span className="primary pointer bold">Reject</span>
      </div>
    ),
  },
];

function Document(props) {
  const res = useTableData(PageableTables.document);
  const { data, loading, pageCount, fetchData, columns, removeRow } = res;
  return (
    <PageableTable
      columns={[...columns, ...getActions(handleUpdateCurried(removeRow))]}
      data={data}
      fetchData={fetchData}
      loading={loading}
      pageCount={pageCount}
      renderRowSubComponent={() => <div>sub</div>}
    />
  );
}

export default Document;



// WEBPACK FOOTER //
// ./src/routes/siteadmin/document/Document.js